import React from 'react';

import {colors} from '../colors/colors';
import {StackLegacy} from '../layout/stack/stack-legacy';
import {LoadingText} from '../loading-placeholder/loading-text';
import {SectionLabel} from '../typography/section-label';

import styles from './placeholder.module.css';

type Props = {
    sectionName: string;
    numRows: number;
    rowMinWidth?: number;
    rowMaxWidth?: number;
    rowHeight?: number;
};

export const SectionPlaceholder = (props: Props) => {
    const loadingTextElements = React.useMemo(() => {
        return [...Array(props.numRows)].map((_, index) => (
            <LoadingText
                key={index.toString()}
                minWidth={props.rowMinWidth || 150}
                maxWidth={props.rowMaxWidth || 300}
                height={props.rowHeight || 15}
                isAnimated={false}
                color={colors.offWhiteDk}
            />
        ));
    }, [props.numRows, props.rowMinWidth, props.rowMaxWidth, props.rowHeight]);

    return (
        <div>
            <div className={styles.header}>
                <SectionLabel noBottomBorder={true} noBottomMargin={true}>
                    {props.sectionName}
                </SectionLabel>
            </div>
            <div className='flex pad-16 flex-dir-col align-start align-self-stretch br-3 border background-offwhite'>
                <StackLegacy spacing={8} isFullWidth={true}>
                    {loadingTextElements}
                </StackLegacy>
            </div>
        </div>
    );
};
